import React, { useCallback, useEffect, useMemo, useState } from "react";
import Loading from "../../../Extra/Loading";
import SAController from "../../7ALoading/SAController";
import { useDispatch, useSelector } from "react-redux";
import { getSevenALoadingDetails } from "../../../../redux-store/thunk/chart.thunk";
import CommodityWiseChart from "../../7ALoading/7AComps/CommodityWiseChart";
import WagonYearWiseChart from "../../7ALoading/7AComps/WagonYearWiseChart";
import CommodityCHWightWiseChart from "../../7ALoading/7AComps/CommodityCHWightWiseChart";
import Wagon from "../../7ALoading/7AComps/Wagon";
import CHWeight from "../../7ALoading/7AComps/CHWeight";
import SummeryData from "../../7ALoading/7AComps/SummeryData";
import SevenASummary from "../../7ALoading/Seven A Summary/SevenASummary";
import EverBest7aSummary from "./EverBest7aSummary";

const EverBest7a = () => {
  const dispatch = useDispatch();
  const [sevenAData, setSevenAData] = useState(null);
  const [moreData, setMoreData] = useState(null);
  const [activePage, setActivePage] = useState("Summary Reports");
  const [FilteredSevenA, setFilteredSevenA] = useState(null);

  const [status, setStatus] = useState(null);
  const [yearsInData, setYearsInData] = useState(null);

  const [openStates, setOpenStates] = useState({
    Year: false,
    "Group Commodity": false,
    "Sub Group Commodity": false,
    Commodity: false,
    Month: false,
    "From Station": false,
    "To Station": false,
  });

  useEffect(() => {
    dispatch(getSevenALoadingDetails());
  }, [dispatch]);

  const { tempData, loading } = useSelector((state) => state.chart);
  useEffect(() => {
    setSevenAData(tempData);
  }, [tempData]);
  useEffect(() => {
    if (moreData) {
      setSevenAData((prev) => ({
        ...prev,
        data7A: [...prev.data7A, moreData.data7A[0]],
        total: [...prev.total, moreData.total],
      }));
    }
  }, [moreData]);
  useEffect(() => {
    if (sevenAData) {
      let tempYear = sevenAData?.data7A?.map((ob) => ob?.F_YEAR);
      setYearsInData(tempYear);
    }
  }, [sevenAData]);

  return (
    <div className="">
      <div className="row   me-2 ms-2"></div>
      {loading && <Loading />}
      {sevenAData ? (
        <div className="sticky-controller">
          <SAController
            setStatus={setStatus}
            data={sevenAData}
            setFilteredSevenA={setFilteredSevenA}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
        </div>
      ) : (
        "No Data Found"
      )}

      <div
        onClick={() => {
          setOpenStates({
            Year: false,
            "Group Commodity": false,
            "Sub Group Commodity": false,
            Commodity: false,
            Month: false,
            "From Station": false,
            "To Station": false,
          });
        }}
      >
        {sevenAData && yearsInData && FilteredSevenA && (
          <EverBest7aSummary
            data={FilteredSevenA}
            setMoreData={setMoreData}
            availableYear={sevenAData.fin_year}
            yearsInData={yearsInData}
          />
        )}
      </div>
    </div>
  );
};

export default EverBest7a;
